import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import posthog from "posthog-js";
import { CB_EVENTS, CB_CHANNELS } from "campaign-builder/analytics/cbAnalytics";
import { SegmentsV1, SegmentsV3 } from "./index";

export const Segments = (props) => {
  const { campaignId, clientId } = useParams();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // PAD-32157 — EDDM keeps its 3 legacy URLs (Segments / design / Submit). Register
  // the channel and capture CB - Audience Reached on Segments mount, in parallel to
  // the legacy EDDM-specific events (Searched initial address to EDDM, Selected
  // one suggested route, etc.) which stay untouched during the transition.
  // Cleanup: unregister channel on unmount so `channel: 'EDDM'` doesn't leak
  // into events emitted by routes the user navigates to after leaving Segments.
  useEffect(() => {
    posthog.register({ channel: CB_CHANNELS.EDDM });
    if (campaignId && clientId) {
      posthog.capture(CB_EVENTS.AUDIENCE_REACHED, { campaign_id: campaignId, client_id: clientId });
    }
    return () => {
      posthog.unregister("channel");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);

    // Add loading timeout to prevent infinite loading
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(loadingTimeout);
    };
  }, []);

  useEffect(() => {
    // Set loading to false after component mounts
    setIsLoading(false);
  }, []);

  // Error boundary
  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">Something went wrong</h2>
          <p className="text-gray-600 mb-4">{error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Reload Page
          </button>
        </div>
      </div>
    );
  }

  // Loading state
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading campaign segments...</p>
        </div>
      </div>
    );
  }

  try {
    if (isMobile) return <SegmentsV1 {...props} />;
    return <SegmentsV3 {...props} />;
  } catch (err) {
    setError(err);
    return null;
  }
};
